module.exports = __webpack_public_path__ + "assets/img/top6.4baaa8b2.webp";